<template>
  <div class="max-w-md">
    <div ref="mainRef">
      <label
        data-required
        class="block text-900 text-sm font-medium"
      >
        邮箱
      </label>
      <InputText
        v-model="email"
        class="mt-2 w-full"
        :pt="{ root: { 'data-focus': 'true' } }"
      />
    </div>

    <div class="mt-4">
      <CodeField
        v-model="code"
        :email="email"
        scene="BIND_EMAIL"
      />
    </div>

    <div class="mt-4">
      <label
        data-required
        class="block text-900 text-sm font-medium"
      >
        {{ _t('auth.pwd') }}
      </label>

      <Password
        v-model="password"
        :feedback="false"
        class="mt-2 w-full"
        inputClass="w-full"
        @keydown.enter="onBindEmail"
      />
    </div>

    <Button
      class="w-full mt-4"
      :label="_t('auth.bind_email')"
      :disabled="!isValid"
      :loading="loading"
      @click="onBindEmail"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { bindEmail } from '@/api/user'
import { useCommonStore } from '@/stores/common-store'
import { isEmail } from '@/utils/misc'
import CodeField from '@/components/AuthCodeField.vue'
const store = useCommonStore()

// 绑定成功时，组件会直接修改 store 信息
const emit = defineEmits<{
  done: []
}>()

const email = ref('')
const code = ref('')
const password = ref('')

const isValid = computed(() => {
  return isEmail(email.value) && code.value !== ''
})

const loading = ref(false)

function onBindEmail() {
  if (!isValid.value) return

  loading.value = true

  bindEmail({
    email: email.value,
    code: code.value,
    password: password.value,
  })
    .then(res => {
      if (res.code === 0) {
        store.user!.email = email.value
        // 绑定邮箱成功 就不是游客了
        store.user!.guest = false
        _message.success(_t('auth.bind_success'))
        emit('done')
      } else {
        _message.info(res.message)
      }
    })
    .finally(() => {
      loading.value = false
    })
}

// auto focus
const mainRef = ref()
onMounted(() => {
  setTimeout(() => {
    mainRef.value.querySelector('input[data-focus]').focus()
  }, 0)
})
</script>

<style scoped></style>
